import { groupBy, sortBySelectors } from "@lyfegen-platform/utils";
import { Box, IconButton } from "@material-ui/core";
import { Delete, FileCopyOutlined } from "@material-ui/icons";
import { combinePaths } from "../../models/flexible/utils";
import { FieldWrapper } from "./FieldWrapper";
import { ISectionRenderProps, SectionRoot } from "./SectionRoot";

export const SectionBody: React.FC<ISectionRenderProps> = (props) => {
	const rows = Array.from(groupBy(props.controller.fieldControllers, (f) => f.schema.row).values()).map((rowElements) =>
		rowElements.sort(sortBySelectors((e) => e.schema.position))
	);

	return (
		<Box paddingX={props.controller.fieldControllers.length ? 3 : undefined}>
			{props.controller.renderBeforeContent?.(props.sectionPath)}
			{props.controller.sectionControllers.map((s, si) => (
				<SectionRoot
					key={si}
					controller={s}
					parentPath={props.sectionPath}
					canDelete={rows.length === 0 && props.canDelete}
					canCopy={rows.length === 0 && props.canCopy}
					initialIndex={props.initialIndex}
					handleCopy={props.handleCopy}
					handleDelete={props.handleDelete}
				/>
			))}
			{rows.map((row, ri) => (
				<Box key={ri} display="flex" flexWrap="wrap">
					{props.controller.renderBeforeRowContent?.(props.sectionPath, ri === 0, ri === rows.length - 1)}
					{row.map((f, fi) => (
						<FieldWrapper
							key={fi}
							controller={f}
							path={combinePaths(props.sectionPath, f.schema.attribute.identifier)}
							initialRowIndex={props.initialIndex}
						/>
					))}
					{props.controller.renderAfterRowContent?.(props.sectionPath, ri === 0, ri === rows.length - 1)}
					{props.canCopy && ri === 0 && (
						<Box display="flex" alignItems="center" ml={2}>
							<IconButton aria-label="copy" onClick={props.handleCopy} color="primary">
								<FileCopyOutlined />
							</IconButton>
						</Box>
					)}
					{props.canDelete && ri === 0 && (
						<Box display="flex" alignItems="center" ml={2}>
							<IconButton aria-label="delete" onClick={props.handleDelete} color="primary">
								<Delete />
							</IconButton>
						</Box>
					)}
				</Box>
			))}
			{props.controller.renderAfterContent?.(props.sectionPath)}
		</Box>
	);
};
